var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.5005,
    r: 32,
    fill: "#2064FA",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.0013,
    cy: 32.4999,
    r: 21.4857,
    fill: "#2064FA",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 22.5C29.2386 22.5 27 24.7386 27 27.5C27 30.2614 29.2386 32.5 32 32.5C34.7614 32.5 37 30.2614 37 27.5C37 24.7386 34.7614 22.5 32 22.5Z",
    fill: "#2064FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9991 33.5C28.0359 33.5 25.4868 34.9462 24.1375 37.155C23.3 38.5259 23.6206 39.9526 24.4767 40.9474C25.298 41.9018 26.6214 42.5 27.9991 42.5H35.9991C37.3768 42.5 38.7001 41.9018 39.5214 40.9474C40.3776 39.9526 40.6981 38.5259 39.8607 37.155C38.5114 34.9462 35.9622 33.5 31.9991 33.5Z",
    fill: "#2064FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserNotify);
export default __webpack_public_path__ + "static/media/user_notify.be1cb632797e9762beaaf728a894a52c.svg";
export { ForwardRef as ReactComponent };